<template>
  <div class="h-100">
    <main role="main" class="h-100">
      <common-master-table
        primary-key="detailDeviceSerialId"
        table-no="mstDetailDevice"
        table-api="master/detail-device"
        ref="commonMasterTable"
        :editable="editableMixin.detailDevice"
        :addable="editableMixin.detailDevice"
        :mapping-no="`ie-detail-device`"
        :hideButtonImportCsv="true"
        socket-entity="DETAIL_DEVICE_SOCKET"
      />
    </main>
  </div>
</template>

<script>
import CommonMasterTable from '../custom-components/CommonMasterTable'
import RouterUtils from '../../_helpers/router.util'
export default {
  components: {
    // コンポーネント分割化
    CommonMasterTable
  },
  data() {
    return {
      removeKeys: [],
      updateQueryStr: ''
    }
  },
  beforeRouteUpdate(to, from) {
    if (to.query && to.query.hasOwnProperty('limit') && Object.keys(to.query).length === 1) {
      RouterUtils.correctTableRowsLimitParam(to.query)
      this.$refs.commonMasterTable.initData()
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/mst-tables/DetailDeviceMaster.vue